var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNightDecoratorDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2215.369,
    height: 138.208,
    viewBox: "0 0 2215.369 138.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#417693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b4a64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1021",
    "data-name": "Union 1021",
    d: "M0,0S6.5,53.292,85.481,53.292c44.348,0,34.5,23.353,63.958,45.093a33.617,33.617,0,0,0,21.857,6.708,33.618,33.618,0,0,0,21.857-6.708c29.459-21.74,19.94-65.788,64.284-65.788C336.413,32.6,342.591,0,342.591,0H0Z",
    transform: "translate(342.591 137.997) rotate(180)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_785",
    "data-name": "Union 785",
    d: "M0,128.923s7.976-65.35,104.821-65.35c54.381,0,42.3-28.637,78.427-55.294a41.22,41.22,0,0,1,26.8-8.226,41.221,41.221,0,0,1,26.8,8.226c36.123,26.657,24.451,80.673,78.827,80.673,96.844,0,104.42,39.968,104.42,39.968H218.165Z",
    transform: "translate(375.219 9.235)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Union_788",
    "data-name": "Union 788",
    d: "M0,137.689S8.519,67.9,111.948,67.9c58.079,0,45.179-30.584,83.761-59.055A44.026,44.026,0,0,1,224.333.056a44.027,44.027,0,0,1,28.625,8.785C291.538,37.312,279.071,95,337.146,95c103.43,0,111.521,42.686,111.521,42.686H233Z",
    transform: "translate(1766.702 -0.003)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Union_1020",
    "data-name": "Union 1020",
    d: "M0,0S5.251,43.154,69.013,43.154c35.8,0,27.852,18.911,51.636,36.515A27.084,27.084,0,0,0,138.3,85.1a27.085,27.085,0,0,0,17.647-5.432c23.784-17.6,16.1-53.273,51.9-53.273C271.6,26.4,276.591,0,276.591,0H0Z",
    transform: "translate(1443.368 137.997) rotate(180)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10045",
    "data-name": "Path 10045",
    d: "M60.1,805.79H220.748c0-25.461-30.98-30.626-48.254-31.151-15.024-.484-18.756-24.412-43.924-21.1-15.216,2.017-16.173,12.953-29.522,15.373C87.277,771.048,60.1,779.965,60.1,805.79Z",
    transform: "translate(1571.333 -667.793)",
    fill: "url(#linear-gradient-2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9138",
    "data-name": "Path 9138",
    d: "M272.084,822.589H60.1c0-33.6,40.88-40.413,63.673-41.1,19.825-.639,24.75-32.213,57.96-27.847,20.078,2.662,21.341,17.092,38.956,20.286C236.222,776.744,272.084,788.512,272.084,822.589Z",
    transform: "translate(496.761 -684.381)",
    fill: "url(#linear-gradient-2)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNightDecoratorDesktop);
export default __webpack_public_path__ + "static/media/bg-night-decorator-desktop.342ea380e8b9d0ab53c05788ea20153e.svg";
export { ForwardRef as ReactComponent };